import PropTypes from 'prop-types';
import React from 'react';
import sanitizeHtml from 'sanitize-html';

import './KeyFeatures.scss';

KeyFeatures.propTypes = {
    content: PropTypes.string.isRequired
};

export default function KeyFeatures({ content }) {
    return (<div
        className='keyFeatures'
        dangerouslySetInnerHTML={{
            __html: sanitizeHtml(content, {
                allowedTags: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'img', 'blockquote', 'code', 'pre', 'table', 'tr', 'td', 'th', 'tbody', 'thead', 'tfoot'],
                allowedAttributes: {
                    a: ['href', 'title', 'target'],
                    img: ['src', 'alt', 'title', 'width', 'height'],
                    '*': ['class', 'id', 'style']
                }
            })
        }}/>);
}
